module.exports = __webpack_public_path__ + "img/benefits_time.03cd105.svg?v=1749539050710";